module.exports = __webpack_public_path__ + "img/digitalOnnuri_2.3689d9f5.png";